import * as api from "./ITProjects.api";
import * as queries from "./ITProjects.queries";
import * as mutations from "./ITProjects.mutations";

export default { ...api, ...queries, ...mutations };
